export default __webpack_public_path__ + "static/media/DSC_7552.0a81b433.jpg";